import { CommandType } from "../../../../common/services/cqs/CommandType";
import { KontraktCommandBase } from "./KontraktCommandBase";

export class CopyKontraktCommand extends KontraktCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CopyKontraktCommand";

    constructor(avtalGuid: string, kontraktGuid: string) {
        super(avtalGuid, kontraktGuid, CopyKontraktCommand.$type, CommandType.Replace);
    }
}
